import { jsx as _jsx } from "react/jsx-runtime";
// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.
import { useState } from "react";
import { cn } from "../cn.js";
const tints = ["bg-[#e7defe] text-[#3b2a99]", "bg-[#fbe4f2] text-[#8a1f5c]", "bg-[#dff3ea] text-[#145c3b]", "bg-[#fff0d6] text-[#7a4a00]", "bg-[#e0ecff] text-[#1f4a9a]"];
/**
 * A rounded square: the person's photo when there is one (src), otherwise initials tinted from
 * the name so the same name keeps its colour. A photo that fails to load falls back to initials.
 */
export function Avatar({ name, size = 20, src, className }) {
    const [failed, setFailed] = useState(null);
    if (src && failed !== src) {
        return (_jsx("img", { src: src, alt: "", "aria-hidden": "true", width: size, height: size, className: cn("shrink-0 rounded-md object-cover", className), style: { width: size, height: size }, onError: () => {
                setFailed(src);
            } }));
    }
    const initials = name.trim().split(/[\s@._-]+/).filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("") || "?";
    let h = 0;
    for (const c of name)
        h = (h * 31 + c.charCodeAt(0)) >>> 0;
    return (_jsx("span", { "aria-hidden": "true", className: cn("inline-flex shrink-0 items-center justify-center rounded-md font-semibold", tints[h % tints.length], className), style: { width: size, height: size, fontSize: Math.round(size * 0.45) }, children: initials }));
}
//# sourceMappingURL=Avatar.js.map